/**
 * IframeEventService - Service for emitting events from iframe to parent window
 *
 * Usage:
 *   import IframeEventService from '@/services/IframeEventService';
 *   IframeEventService.emit('page_loaded', null);
 */

/**
 * Check if the app is inside an iframe
 */
function isInsideIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

class IframeEventService {
  /**
   * Emit a structured event to parent window
   * @param {string} type - Event type
   * @param {any} detail - Event payload/data
   */
  static emit(type, detail = null) {
    if (isInsideIframe()) {
      parent.postMessage({ type, detail }, '*');
    }
  }

  /**
   * Check if currently inside iframe
   * @returns {boolean}
   */
  static isInsideIframe() {
    return isInsideIframe();
  }

  /**
   * Emit status_page event
   * @param {Object} payload - { status, resolution, id }
   */
  static emitStatusPage(payload) {
    this.emit('status_page', payload);
  }

  /**
   * Emit processed event
   * @param {Object} payload - { status, resolution, id, amount, currency }
   */
  static emitProcessed(payload) {
    this.emit('processed', payload);
  }

  /**
   * Emit error event
   * @param {Object} payload - { message, id? }
   */
  static emitError(payload) {
    this.emit('error', payload);
  }

  /**
   * Emit redirect event
   * @param {string} url - Redirect URL
   */
  static emitRedirect(url) {
    this.emit('redirect', url);
  }
}

export default IframeEventService;
